import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as i, openBlock as d, normalizeClass as o, createElementVNode as l } from "vue";
import { _ as n } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconForward",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ l("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M7.646 3.146a.5.5 0 0 1 .708 0l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 1 1-.708-.708L9.293 6.5H4.5A1.5 1.5 0 0 0 3 8v1a.5.5 0 0 1-1 0V8a2.5 2.5 0 0 1 2.5-2.5h4.793L7.646 3.854a.5.5 0 0 1 0-.708Z",
  "clip-rule": "evenodd"
}, null, -1), m = [
  _
];
function u(e, f, r, h, p, a) {
  return d(), i("svg", {
    "aria-label": r.ariaLabel,
    class: o([a.iconSizeClass, "d-icon d-icon--forward"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Forward",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 12"
  }, m, 10, c);
}
const g = /* @__PURE__ */ n(s, [["render", u]]);
export {
  g as default
};
//# sourceMappingURL=forward.js.map
